import axios, { isAxiosError } from 'axios';

export const http = () => axios;
export default http;

/**
 * Check if an error is a backend error (5xx status code).
 * Useful to distinguish backend issues from network/client errors.
 */
export const isBackendError = (error: unknown): boolean => {
  return isAxiosError(error) && !!error.response?.status && error.response.status >= 500;
};
